module.exports = __webpack_public_path__ + "static/slider-1-a8c38b0778e4a542b074d86315f7cd6d.png";